import { useChatCopy } from '@/lib/chat-i18n';

/** Canvas chrome reuses the localized app catalog rather than introducing English UI strings. */
export function useCanvasCopy() {
  const copy = useChatCopy();
  return {
    back: copy.previous,
    close: copy.close,
    activity: copy.toolActivity,
    activityUnavailable: copy.activityUnavailable,
    more: copy.more,
    copyLink: copy.canvasCopyLink,
    linkCopied: copy.canvasLinkCopied,
    copyLinkFailed: copy.canvasCopyLinkFailed,
    openInAgent: copy.canvasOpenInAgent,
    expand: copy.canvasExpand,
    exitFullView: copy.canvasExitFullView,
  };
}
